// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wxbSky-4GfipXKDQvWnk9","title":"_2dObnbbhfHUZwS6i59YqxR","backArrow":"PbAhLo2AdnQBzqO_Zr-a6","backLink":"_27fH9VoYO1ICSvLc7X-jyK","backLinkWrap":"_1iMCc7yQJhdhKYFGPI5JO"};